import { useAuthStore, useQueryWithUserId } from '@northladder/services';

import { INV_MGMT_SERVICE_API } from '../../../InventoryManagementClient';

/**
 * This is to track cache for the inventory scan options.
 */
export const FETCH_INVENTORY_SCAN = 'fetch-inventory-scan-options-query';

/**
 * Custom hook to fetch the inventory scan options.
 */
export const useInventoryScanOptionsQuery = () => {
  const userId = useAuthStore.getState()?.activeSession?.userId || '';

  const { data, isPending, isError, error, isPaused, refetch, isFetching } =
    useQueryWithUserId({
      queryKey: [FETCH_INVENTORY_SCAN, userId],
      networkMode: 'always', // Even make calls when offline
      queryFn: () => INV_MGMT_SERVICE_API.getInventoryScanOptions(),
    });

  return {
    error,
    isScanOptionsLoading: isPending,
    isError,
    isPaused,
    scanOptions: data,
    refetchScanOptions: refetch,
    isScanOptionsFetching: isFetching,
  };
};
